// extracted by mini-css-extract-plugin
export default {"table":"Table_table__Zr17r","table__scroll":"Table_table__scroll__rk2Po","table__not_found":"Table_table__not_found__fFIB9"};